'use client'
import { useState } from 'react'

function IconArrowRight(p: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="square" {...p}>
      <path d="M5 12 H19 M13 6 L19 12 L13 18" />
    </svg>
  )
}

export default function NewsletterForm() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(false)
    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      if (res.ok) {
        setSubmitted(true)
      } else {
        setError(true)
      }
    } catch {
      setError(true)
    }
  }

  if (submitted) {
    return (
      <div
        className="mono"
        style={{ fontSize: 12, letterSpacing: '0.14em', color: 'var(--accent)', textTransform: 'uppercase' }}
      >
        ✓ You&apos;re subscribed.
      </div>
    )
  }

  return (
    <form className="newsletter-form" onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 8, flexShrink: 0 }} suppressHydrationWarning>
      <div className="newsletter-form-fields" style={{ display: 'flex', gap: 0 }}>
        <input
          className="newsletter-form-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          aria-label="Email address"
          required
          style={{
            padding: '14px 16px',
            fontSize: 14,
            fontFamily: 'var(--font-body)',
            background: 'rgba(255,255,255,0.06)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRight: 'none',
            borderRadius: 'var(--r-1) 0 0 var(--r-1)',
            outline: 'none',
            minWidth: 240,
            boxSizing: 'border-box',
          }}
        />
        <button
          type="submit"
          className="btn btn-primary"
          style={{ borderRadius: '0 var(--r-1) var(--r-1) 0', whiteSpace: 'nowrap' }}
        >
          Subscribe <IconArrowRight width={14} height={14} />
        </button>
      </div>
      {error && (
        <p style={{ fontSize: 12, color: 'rgba(255,100,100,0.9)', margin: 0 }}>
          Something went wrong. Please try again.
        </p>
      )}
    </form>
  )
}
